module.exports = __webpack_public_path__ + "img/root010.a6c63396.png";